import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  shipmentContainer: {
    marginBottom: theme.spacing(3),
  },

  cancelMessageContainer: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[300]}`,
  },

  cancelMessageIcon: {
    backgroundColor: theme.palette.grey[200],
  },
});
